import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';

import {
  CommonFlex,
  CommonGrid,
  CommonText,
} from '../../styledComponents/common';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ innerChartData, outerChartData, height = '250px' }) => {
  const [innerChartZIndex, setInnerChartZIndex] = useState(5); // Default z-index for inner chart
    


  const { allotted_quantity, remaining, ...rest } = innerChartData;
  let newInnerChartData = rest

  if(newInnerChartData.current_quantity >= allotted_quantity) {
    newInnerChartData.remaining = 0
  }
  else {
    newInnerChartData.remaining = remaining
  }

  // console.log("New Inner Chart Data ", newInnerChartData, allotted_quantity);

  const innerData = {
    labels: Object.keys(newInnerChartData).map(key => t(key)),
    datasets: [
      {
        label: t('quantity'),
        data: Object.values(newInnerChartData),
        backgroundColor: ['#3B7D23', '#E97132'],
      },
    ],
  };

  const outerData = {
    labels: Object.keys(outerChartData).map(key => t(key)),
    datasets: [
      {
        label: t('quantity'),
        data: Object.values(outerChartData),
        backgroundColor: [
          '#B05323',
          '#CE632B',
          '#E97132',
          '#EEA18A',
          '#F3C4B8',
        ],
        cutout: '75%',
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        position: 'nearest',
        callbacks: {
          label: function(context) {

            const label = context.label || '';
            const value = context.raw || 0;

            if (label === "Remaining") {
              return `${label}: ${newInnerChartData.current_quantity > allotted_quantity ? remaining : value}`;
            }

            return `${label}: ${value}`;
          }
        }
      },
    },
    interaction: {
      mode: 'nearest',
      intersect: false,
    },
  };

  useEffect(() => {
    // Force tooltips to be above everything using CSS
    const tooltipStyle = document.createElement('style');
    tooltipStyle.innerHTML = `
      .chartjs-tooltip {
        z-index: 9999 !important;
        position: absolute !important;
      }
    `;
    document.head.appendChild(tooltipStyle);

    return () => {
      document.head.removeChild(tooltipStyle);
    };
  }, []);

  const handleOuterChartHover = () => {
    setInnerChartZIndex(1);
  };

  const handleOuterChartLeave = () => {
    setInnerChartZIndex(5);
  };

  return (
    <CommonGrid
      columns="1fr 30%"
      style={{
        // backgroundColor: 'red',
        width: '100%',
      }}
      gap="5px"
    >
      <div
        style={{
          width: height,
          height: height,
          margin: 'auto',
          position: 'relative',
          // backgrouxndColor: 'green',
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: height,
            minHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Outer Chart */}
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: height,
              minHeight: '100%',
              zIndex: 2,
            }}
            onMouseEnter={handleOuterChartHover}
            onMouseLeave={handleOuterChartLeave}
          >
            <Pie data={outerData} options={options} />
          </div>

          <div
            style={{
              position: 'absolute',
              width: '65%',
              height: '65%',
              borderRadius: '50%',
              backgroundColor: 'transparent',
              zIndex: innerChartZIndex === 5 ? 1 : 10,
            }}
          />

          {/* Inner Chart */}
          <div
            style={{
              width: '65%',
              height: '65%',
              position: 'relative',
              zIndex: innerChartZIndex,
            }}
          >
            <Pie data={innerData} options={options} />
          </div>
        </div>
      </div>
      <CommonFlex
        direction="column"
        gap="5px"
        alignItems="flex-start"
        justifyContent="start"
      >
        {Object.keys(newInnerChartData).map((key, index) => (
          <CommonFlex
            key={index}
            gap="10px"
            alignItems="flex-start"
            justifyContent="start"
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: innerData.datasets[0].backgroundColor[index],
                borderRadius: '2px',
              }}
            />
            <CommonText fontSize="11px">{t(key)}</CommonText>
          </CommonFlex>
        ))}
        {Object.keys(outerChartData).map((key, index) => (
          <CommonFlex
            key={index}
            gap="10px"
            alignItems="flex-start"
            justifyContent="start"
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: outerData.datasets[0].backgroundColor[index],
                borderRadius: '2px',
              }}
            />
            <CommonText fontSize="11px">{t(key)}</CommonText>
          </CommonFlex>
        ))}
      </CommonFlex>
    </CommonGrid>
  );
};

export default PieChart;


